// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17BUO","toggle":"styles_toggle__ERRtr","preview":"styles_preview__1Ng1H"};